import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from './cn.js';
/**
 * Multi-line text: a site description, a role description, a revoke note.
 * Vertical resize only, minimum two rows, a character counter in the hint
 * position when there is a limit.
 */
const Textarea = React.forwardRef(({ className, invalid, showCount = false, maxLength, value, defaultValue, onChange, ...props }, ref) => {
    const { t } = useTranslation();
    const [length, setLength] = React.useState(String(value ?? defaultValue ?? '').length);
    React.useEffect(() => {
        if (value != null)
            setLength(String(value).length);
    }, [value]);
    const textarea = (_jsx("textarea", { ref: ref, "data-slot": "textarea", rows: 2, maxLength: maxLength, value: value, defaultValue: defaultValue, "aria-invalid": invalid || props['aria-invalid'] || undefined, onChange: (event) => {
            setLength(event.target.value.length);
            onChange?.(event);
        }, className: cn('placeholder:text-muted-foreground dark:bg-input/30 border-input hover:border-input-hover flex min-h-[calc(var(--control-h)*2.2)] w-full min-w-0 resize-y rounded-md border bg-transparent px-3 py-2 text-ui transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:opacity-50', 'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]', 'aria-invalid:border-destructive aria-invalid:ring-destructive/30', className), ...props }));
    if (!showCount || maxLength == null)
        return textarea;
    return (_jsxs("div", { className: "flex flex-col gap-1", children: [textarea, _jsx("span", { className: "self-end text-caption text-muted-foreground tnum", "aria-live": "polite", children: t('kit.characters', { count: length, max: maxLength }) })] }));
});
Textarea.displayName = 'Textarea';
export { Textarea };
//# sourceMappingURL=textarea.js.map